'use client';

import useVelocityStore, {
	VelocityStore,
} from 'src/stores/VelocityStore/useVelocityStore';

const FILTER_DEFAULTS = {
	showPerpMarkets: {
		tradePage: true,
		overviewPage: true,
	},
	showSpotMarkets: {
		// only for orders table
		tradePage: true,
		overviewPage: true,
	},
};

export const useTableFiltersState = (props: { overviewPage?: boolean }) => {
	const stateKey = props.overviewPage
		? 'overviewPageTableFilters'
		: 'tradePageTableFilters';

	const setStore = useVelocityStore((s) => s.set);
	const tradePageTableFilters = useVelocityStore(
		(s) => s[stateKey]
	) as VelocityStore['tradePageTableFilters'];

	const showPerpMarketsDefaultValue = props.overviewPage
		? FILTER_DEFAULTS.showPerpMarkets.overviewPage
		: FILTER_DEFAULTS.showPerpMarkets.tradePage;

	const showSpotMarketsDefaultValue = props.overviewPage
		? FILTER_DEFAULTS.showSpotMarkets.overviewPage
		: FILTER_DEFAULTS.showSpotMarkets.tradePage;

	const showOnlyCurrentMarket = tradePageTableFilters.showOnlyCurrentMarket;

	const showPerpMarkets =
		tradePageTableFilters.showPerpMarkets === undefined
			? showPerpMarketsDefaultValue
			: tradePageTableFilters.showPerpMarkets;

	const showSpotMarkets =
		tradePageTableFilters.showSpotMarkets === undefined
			? showSpotMarketsDefaultValue
			: tradePageTableFilters.showSpotMarkets;

	const setShowOnlyCurrentMarket = (newValue: boolean) => {
		setStore((s) => {
			s[stateKey].showOnlyCurrentMarket = newValue;
		});
	};

	const setShowPerpMarkets = (newValue: boolean) => {
		setStore((s) => {
			s[stateKey].showPerpMarkets = newValue;
			s[stateKey].showOnlyCurrentMarket = false;
		});
	};

	const setShowSpotMarkets = (newValue: boolean) => {
		setStore((s) => {
			s[stateKey].showSpotMarkets = newValue;
			s[stateKey].showOnlyCurrentMarket = false;
		});
	};

	return {
		showOnlyCurrentMarket,
		showPerpMarkets,
		showSpotMarkets,
		setShowOnlyCurrentMarket,
		setShowPerpMarkets,
		setShowSpotMarkets,
	};
};
